import { render, staticRenderFns } from "./PermissionTreeNode.vue?vue&type=template&id=67879f1e&scoped=true"
import script from "./PermissionTreeNode.vue?vue&type=script&lang=js"
export * from "./PermissionTreeNode.vue?vue&type=script&lang=js"
import style0 from "./PermissionTreeNode.vue?vue&type=style&index=0&id=67879f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67879f1e",
  null
  
)

export default component.exports